import { getConfigInterceptors } from '@shared/utils'
import axios from 'axios'

import { OpenAPI } from './requests'

OpenAPI.BASE = import.meta.env.VITE_APP_NOTIFICATION_API

export const $notificationAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_NOTIFICATION_API,

  headers: {
    'Content-Type': 'application/json'
  }
})

getConfigInterceptors($notificationAxios, false)
